import React from 'react';

const weekDays = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];

interface WeekTabsProps {
  selected: number;
  onSelect: (idx: number) => void;
}

const WeekTabs: React.FC<WeekTabsProps> = ({ selected, onSelect }) => (
  <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
    {weekDays.map((day, idx) => (
      <button
        key={day}
        onClick={() => onSelect(idx)}
        style={{
          padding: '8px 18px',
          borderRadius: 20,
          border: 'none',
          background: selected === idx ? 'linear-gradient(90deg, #4fd1c5 0%, #38b2ac 100%)' : '#f1f5f9',
          color: selected === idx ? '#fff' : '#222',
          fontWeight: selected === idx ? 700 : 500,
          fontSize: 16,
          cursor: 'pointer',
          boxShadow: selected === idx ? '0 2px 8px rgba(72,187,120,0.10)' : 'none',
          transition: 'background 0.2s, color 0.2s',
        }}
      >
        {day}
      </button>
    ))}
  </div>
);

export default WeekTabs; 